// extracted by mini-css-extract-plugin
module.exports = {"layout":"Hero_layout___3DRh","root":"Hero_root__AVrnX","title":"Hero_title__Z_pEn","categoryCarousel":"Hero_categoryCarousel__3i22n","buttonsDesktop":"Hero_buttonsDesktop__WlZKD"};